import React, {} from 'react';
const styles = {"callToAction":"CallToAction-module__callToAction__ICgAI","button":"CallToAction-module__button__cd09d","note":"CallToAction-module__note__CJFvd"};
/** The landing page's orange pill link to sign-up, with an optional small note under it. */
export function CallToAction({ label, href, note }) {
    return (React.createElement("div", { className: styles.callToAction },
        React.createElement("a", { className: styles.button, href: href }, label),
        note !== undefined && React.createElement("p", { className: styles.note }, note)));
}
//# sourceMappingURL=CallToAction.js.map